import { render } from "./AgeSliderComponent.vue?vue&type=template&id=243db114&scoped=true"
import script from "./AgeSliderComponent.vue?vue&type=script&lang=js"
export * from "./AgeSliderComponent.vue?vue&type=script&lang=js"

import "./AgeSliderComponent.vue?vue&type=style&index=0&id=243db114&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243db114"]])

export default __exports__